import { render, staticRenderFns } from "./FooterButtonv2.vue?vue&type=template&id=71ae878e&scoped=true&"
import script from "./FooterButtonv2.vue?vue&type=script&lang=js&"
export * from "./FooterButtonv2.vue?vue&type=script&lang=js&"
import style0 from "./FooterButtonv2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FooterButtonv2.vue?vue&type=style&index=1&id=71ae878e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae878e",
  null
  
)

export default component.exports